
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("b6A6z", function(module, exports) {
/* eslint-disable @repo/internal/import/no-unresolved */ 
var $cglvp = parcelRequire("cglvp");

const $059afa58187a2540$var$PUBLIC_APP_IDS = {
    noBackend: 'a3f31403-5892-4b68-baf9-a8b1c1f9ef80',
    staging: '811e05d4-b0aa-4ec9-80e4-68cf5e924102',
    production: {
        development: 'dba4f6db-8419-44f6-ac25-32b6fc352747',
        userFacing: '8e345daf-482a-4abf-a612-cb6457110817'
    }
};
const $059afa58187a2540$export$c150e4a8d8a3ab35 = ({ environment: environment, jws: jws, siteId: siteId, productName: productName, entryPointName: entryPointName })=>{
    const commonParams = {
        jws: jws,
        siteId: siteId,
        config: {
            enableNewUi: true,
            productName: productName,
            entryPointName: entryPointName
        }
    };
    if (environment === 'dev') return {
        ...commonParams,
        mode: 'standard',
        publicAppId: $059afa58187a2540$var$PUBLIC_APP_IDS.noBackend,
        environment: 'production'
    };
    if (environment === 'staging') return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: $059afa58187a2540$var$PUBLIC_APP_IDS.staging,
        environment: 'staging'
    };
    return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: (0, $059afa58187a2540$var$PUBLIC_APP_IDS.production.userFacing),
        environment: 'production'
    };
};


const $2049fe8012434f76$export$703005ecc9b7c87e = {
    UNSUPPORTED_BROWSER: 'unsupported-browser',
    UNSUPPORTED_MEDIA_STREAMING: 'unsupported-media-streaming',
    UNSUPPORTED_3RD_PARTY_COOKIE: 'unsupported-third-party-cookie',
    UNSUPPORTED_UNKNOWN: 'unsupported-unknown',
    TOKEN_UNSUCCESSFUL: 'token-unsuccessful',
    UNMERGED_USER: 'token-unsuccessful-unmerged-user',
    TOKEN_EMPTY: 'token-empty',
    NETWORK: 'network',
    LOOM_INTERNAL_ERROR: 'loom-internal-error',
    UNKNOWN: 'unknown'
};
class $2049fe8012434f76$var$LoomInitError extends Error {
    constructor(type, message){
        super(message);
        this.type = void 0;
        this.type = type;
    }
}
function $2049fe8012434f76$var$mapLoomUnsupportedTypeToSubType(unsupportedReason) {
    switch(unsupportedReason){
        case 'incompatible-browser':
            return $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_BROWSER;
        case 'third-party-cookies-disabled':
            return $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_3RD_PARTY_COOKIE;
        case 'no-media-streams-support':
            return $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_MEDIA_STREAMING;
        default:
            return $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_UNKNOWN;
    }
}
async function $2049fe8012434f76$var$fetchJsonFromUrl(url, method = 'GET', expectedStatuses = []) {
    try {
        const response = await fetch(url, {
            method: method,
            headers: {
                Accept: 'application/json'
            }
        });
        if (!response.ok && !expectedStatuses.includes(response.status)) throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$export$703005ecc9b7c87e.NETWORK, response.statusText);
        const data = await response.json();
        return data;
    } catch (error) {
        throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$export$703005ecc9b7c87e.NETWORK, error instanceof Error ? error.message : '');
    }
}
async function $2049fe8012434f76$var$getAuthToken() {
    const { token: token, message: message } = await $2049fe8012434f76$var$fetchJsonFromUrl('/gateway/api/loom-auth/api/internal/auth/sdk_token', 'POST', [
        404
    ]);
    if (message === 'Loom user needs merge') throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$export$703005ecc9b7c87e.UNMERGED_USER);
    if (message !== 'Success') {
        let userStatus;
        try {
            // we don't want a failure to make the identity check to mask the original issue
            const { status: status } = await $2049fe8012434f76$var$fetchJsonFromUrl('/gateway/api/loom-auth/api/internal/identity/user-status', 'GET');
            userStatus = status;
        } catch (error) {
            userStatus = 'unknown user status';
        }
        throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$export$703005ecc9b7c87e.TOKEN_UNSUCCESSFUL, `${message} , ${userStatus}`);
    }
    if (!token) throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$export$703005ecc9b7c87e.TOKEN_EMPTY);
    return token;
}


async function $2049fe8012434f76$var$_init({ cloudId: cloudId, environment: environment, productName: productName, experienceTracker: experienceTracker, entryPointLocation: entryPointLocation }) {
    let loomSDKInstance;
    try {
        (0, $cglvp.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        experienceTracker.start({
            id: (0, $cglvp.INITIALIZE_LOOM_ENTRY_POINT),
            name: (0, $cglvp.INITIALIZE_LOOM_ENTRY_POINT),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        const { isSupported: isSupported } = await (parcelRequire("aWuvK"));
        const { supported: supported, error: error } = isSupported();
        if (!supported) throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$var$mapLoomUnsupportedTypeToSubType(error));
        const recorderToken = environment === 'dev' ? '' : await $2049fe8012434f76$var$getAuthToken();
        const { createInstance: createInstance } = await (parcelRequire("cTCR9"));
        loomSDKInstance = await createInstance((0, $059afa58187a2540$export$c150e4a8d8a3ab35)({
            environment: environment,
            jws: recorderToken,
            siteId: cloudId,
            productName: productName,
            entryPointName: entryPointLocation
        }));
        if (!loomSDKInstance.status().success) throw new $2049fe8012434f76$var$LoomInitError($2049fe8012434f76$export$703005ecc9b7c87e.LOOM_INTERNAL_ERROR, 'Loom SDK timeout or another internal issue');
        experienceTracker.succeed({
            name: (0, $cglvp.INITIALIZE_LOOM_ENTRY_POINT),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        (0, $cglvp.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
    } catch (error) {
        (0, $cglvp.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
        if (error instanceof $2049fe8012434f76$var$LoomInitError) {
            if (error.type === $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_BROWSER || error.type === $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_MEDIA_STREAMING || error.type === $2049fe8012434f76$export$703005ecc9b7c87e.UNSUPPORTED_3RD_PARTY_COOKIE || error.type === $2049fe8012434f76$export$703005ecc9b7c87e.UNMERGED_USER) experienceTracker.succeed({
                name: (0, $cglvp.INITIALIZE_LOOM_ENTRY_POINT),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            else experienceTracker.fail({
                name: (0, $cglvp.INITIALIZE_LOOM_ENTRY_POINT),
                error: new Error(error.type),
                attributes: {
                    entryPointLocation: entryPointLocation
                }
            });
            return {
                kind: 'failure',
                initError: {
                    type: error.type,
                    message: error.message
                }
            };
        }
        experienceTracker.fail({
            name: (0, $cglvp.INITIALIZE_LOOM_ENTRY_POINT),
            error: new Error($2049fe8012434f76$export$703005ecc9b7c87e.UNKNOWN),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        if (error instanceof Error) return {
            kind: 'failure',
            initError: {
                type: $2049fe8012434f76$export$703005ecc9b7c87e.UNKNOWN,
                message: error.message
            }
        };
        return {
            kind: 'failure',
            initError: {
                type: $2049fe8012434f76$export$703005ecc9b7c87e.UNKNOWN
            }
        };
    }
    return {
        kind: 'success',
        loomSDKInstance: loomSDKInstance
    };
}
// this will hold our singleton result instance
let $2049fe8012434f76$var$initSDKResultPromise;
function $2049fe8012434f76$export$a6ae7697c0f5af9d(params) {
    // Singleton
    if ($2049fe8012434f76$var$initSDKResultPromise === undefined) $2049fe8012434f76$var$initSDKResultPromise = $2049fe8012434f76$var$_init(params);
    return $2049fe8012434f76$var$initSDKResultPromise;
}
function $2049fe8012434f76$export$1702a3de4c96a056() {
    $2049fe8012434f76$var$initSDKResultPromise = undefined;
}
module.exports["LoomInitErrorException"] = $2049fe8012434f76$export$703005ecc9b7c87e;
module.exports["initLoomSDK"] = $2049fe8012434f76$export$a6ae7697c0f5af9d;
module.exports["resetInstance"] = $2049fe8012434f76$export$1702a3de4c96a056;

});

parcelRegister("cglvp", function(module, exports) {

var $kyiqo = parcelRequire("kyiqo");

const $e7fdbca395b7a04f$export$873f91e3be81ab94 = (0, $kyiqo.metrics).interaction({
    key: 'open-loom-recorder-sdk'
});
const $e7fdbca395b7a04f$export$bf1068aa9f020d8f = (0, $kyiqo.metrics).interaction({
    key: 'initialize-loom-recorder-sdk'
});
const $e7fdbca395b7a04f$export$5e1aeeb6f31be57a = 'record-loom-entry-point';
const $e7fdbca395b7a04f$export$fdda1c9b501679e3 = 'initialize-loom-entry-point';
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $e7fdbca395b7a04f$export$873f91e3be81ab94;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $e7fdbca395b7a04f$export$bf1068aa9f020d8f;
module.exports["RECORD_LOOM_ENTRY_POINT"] = $e7fdbca395b7a04f$export$5e1aeeb6f31be57a;
module.exports["INITIALIZE_LOOM_ENTRY_POINT"] = $e7fdbca395b7a04f$export$fdda1c9b501679e3;

});

parcelRegister("aWuvK", function(module, exports) {

let $7f76fd05798145a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f76fd05798145a7$var$load("lwKXH"),
    $7f76fd05798145a7$var$load("4byV5")
]).then(()=>parcelRequire('3f9PV'));

});

parcelRegister("cTCR9", function(module, exports) {

let $9638c321c652ab29$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9638c321c652ab29$var$load("lkOIY"),
    $9638c321c652ab29$var$load("kAAjo"),
    $9638c321c652ab29$var$load("fbRdC"),
    $9638c321c652ab29$var$load("kWZnd"),
    $9638c321c652ab29$var$load("92LGf"),
    $9638c321c652ab29$var$load("6wr18"),
    $9638c321c652ab29$var$load("a3Uq6"),
    $9638c321c652ab29$var$load("SqT67"),
    $9638c321c652ab29$var$load("xvDzM"),
    $9638c321c652ab29$var$load("jle6Z"),
    $9638c321c652ab29$var$load("4drdS"),
    $9638c321c652ab29$var$load("lLK0D"),
    $9638c321c652ab29$var$load("9LQGG"),
    $9638c321c652ab29$var$load("wIOhQ"),
    $9638c321c652ab29$var$load("lwKXH"),
    $9638c321c652ab29$var$load("fisfU"),
    $9638c321c652ab29$var$load("9a2oY"),
    $9638c321c652ab29$var$load("ffEVr"),
    $9638c321c652ab29$var$load("7EorR"),
    $9638c321c652ab29$var$load("btYwu")
]).then(()=>parcelRequire('fIeud'));

});


//# sourceMappingURL=initLoomSDK.03243649.js.map
